import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { setFontVariant } from "@similarweb/styles";

const DEFAULT_TEXT_AREA_BORDER = `1px solid ${colorsPalettes.midnight[50]}`;

export const TextArea = styled.textarea`
    height: 120px;
    width: 100%;
    border: ${DEFAULT_TEXT_AREA_BORDER};
    ${setFontVariant("body2", colorsPalettes.carbon[500])};
    resize: none;
    &:focus {
        border: ${DEFAULT_TEXT_AREA_BORDER};
    }
`;

export const PlaceHolder = styled.span<{ isVisible: boolean }>`
    position: absolute;
    left: 8px;
    bottom: 20px;
    visibility: ${({ isVisible }) => (isVisible ? `visible` : "hidden")};
`;

export const EmailContainer = styled.div`
    position: relative;
    margin-bottom: 8px;
`;
